import React from "react"
import { IconButton, Typography } from "@material-ui/core"
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { mdiAttachment, mdiCloseCircleOutline } from "@mdi/js"
import Icon from "@mdi/react"

type Props = {
    id: string;
    getFile: () => any;
    file: any;
    fileName: string;
    link?: string;
    handleChangeFileInput: (event: any) => void;
    lable: string;
    onClick: () => void;
    onDelete: () => void;
    accept?: string;
    disabled?: boolean
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        textInput: {
            '& input, .MuiSelect-root': {
                padding: '12px 10px 12px !important',
            },

            '& .MuiInput-underline::before': {
                borderBottom: '1px solid #d8d8d8 !important',
            },
        },
        uploadInput: {
            // cursor: 'pointer',
            alignSelf: 'center',
            position: 'absolute',
            top: '0',
            right: '0',
            width: '100%',
            height: '100%',
            opacity: '0',
        },
        labelInput: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '15px',
            border: '1.5px dashed rgba(0, 0, 0, 0.25)',
            borderRadius: '4px',
            width: '100%',
            height: '100%',
            maxWidth: '500px',
            // cursor: 'pointer'
        },
        label: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            // cursor: 'pointer'
        },
        overlay: {
            position: 'absolute',
            top: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            backgroundColor: "#E7F7F3",
        },
        link: {
            color: "#03614B"
        },
        linkButton: {
            border: "none",
            background: "none",
            textDecoration: "underline",
            // cursor: 'pointer'
        }
    }),
);


const FileWithLink = (props: Props) => {
    const classes = useStyles();

    const downLoadFile = async () => {
        try {
            const file = await props.getFile();
            const link = document.createElement('a');
            link.href = file;
            link.setAttribute(
                'download',
                props.fileName,
            );
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

        } catch (error: any) {
            //   handleError(error)
        }
    }

    return (
        <div className={classes.labelInput}>
            {(props.fileName || props.link) && <div className={classes.overlay}>
                {props.link && <a className={classes.link} href={`//${props.link}`} target="_blank">لینک فایل</a>}
                {props.fileName && <button type="button" onClick={downLoadFile} className={classes.linkButton}>{props.fileName.substring(0, 30)}</button>}
                <IconButton onClick={props.onDelete}>
                    <Icon
                        color={'#FF0000'}
                        path={mdiCloseCircleOutline}
                        size={1}
                        style={{ marginRight: "5px" }}
                    />
                </IconButton>
            </div>}
            <label htmlFor={props.id} className={classes.label}
                style={{ cursor: props.disabled ? "default" : "pointer" }}
            >

                <Icon
                    color={'#00000040'}
                    path={mdiAttachment}
                    size={1.5}
                />
                <Typography style={{
                    color: props.disabled ? '#bdbdbd' : "#000",
                }}>
                    {props.lable}
                </Typography>
                <input
                    type="file"
                    name={props.fileName}
                    id={props.id}
                    onChange={props.handleChangeFileInput}
                    className={classes.uploadInput}
                    accept={props.accept ? props.accept : "all"}
                    disabled={props.disabled}
                    hidden
                />
            </label>
            یا
            <Typography
                style={{
                    color: props.disabled ? '#bdbdbd' : '#0375E8',
                    borderBottom: props.disabled ? 'solid 1px #bdbdbd' : 'solid 1px #0375E8',
                    cursor: props.disabled ? "default" : "pointer"
                }}
                onClick={props.disabled ? undefined : props.onClick}
            >
                افزودن لینک
            </Typography>
        </div>
    )
}

export default FileWithLink;